import type { $Fetch } from "nitropack";

export interface CreateTrackingEventBody {
  category: string;
  action: string;
  page_url: string;
  referrer: string | null;
  screen_w: number | null;
  screen_h: number | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
}

export const TrackingRepository = (client: $Fetch) => ({
  create: (body: CreateTrackingEventBody) =>
    client("/v2/tracking/events", { method: "POST", body }),
});
